export * from "./types.js";
export * from "./copy.js";
export {
  intestacyDistribution,
  estateReadiness,
  statutoryLegacyForDate,
  assertEstateOnly,
  assertNoAffiliate,
  FinancialProductError,
  AffiliateOnSurfaceError,
} from "./calculate.js";
export { nsw } from "./nsw.js";
export { vic } from "./vic.js";
export { qld } from "./qld.js";

import type { IntestacyRuleSet, IntestacyState } from "./types.js";
import { nsw } from "./nsw.js";
import { vic } from "./vic.js";
import { qld } from "./qld.js";

/**
 * Registry of intestacy rulesets keyed by state. Each state's statutory legacy
 * reprices on its own schedule (NSW quarterly, VIC annually, QLD fixed) within
 * the ruleset; historical periods stay inside each ruleset so a backdated estate
 * resolves against the legacy in force on the date of death. Never mutate a
 * shipped value — append a new dated period.
 */
export const INTESTACY_RULESETS: Record<IntestacyState, IntestacyRuleSet> = {
  NSW: nsw,
  VIC: vic,
  QLD: qld,
};

/** Resolve the intestacy ruleset for a state, or throw if unknown. */
export function intestacyRulesFor(state: IntestacyState): IntestacyRuleSet {
  const rules = INTESTACY_RULESETS[state];
  if (!rules) throw new Error(`no intestacy ruleset registered for ${state}`);
  return rules;
}

/** The states shipped in the MVP — the default offer. */
export const INTESTACY_CURRENT_STATES: readonly IntestacyState[] = [
  "NSW",
  "VIC",
  "QLD",
];
